<template>
  <div>
    <v-snackbar
      v-if="indeterminate"
      :color="color"
      top
      right
      v-model="show"
      indeterminate
      :timeout="0"
      key="inter"
    >
      {{ message }}
      <v-btn text @click.native="show = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar
      v-else
      :timeout="timeout"
      :color="color"
      top
      right
      v-model="show"
      key="timed"
    >
      <h2 v-if="large">
        {{ message }}
      </h2>
      <template v-else> {{ message }}</template>
      <v-btn text @click.native="show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "AppSnackbar",
  data() {
    return {
      timeout: 5000,
      color: "success",
      show: false,
      large: false,
    };
  },
  computed: {
    indeterminate() {
      return (
        this.$store.getters.appSnackbar.color == "error" ||
        this.$store.getters.appSnackbar.color == "warning"
      );
    },
    message() {
      if (this.$store.getters.appSnackbar) {
        if (this.$store.getters.appSnackbar.color) {
          this.color = this.$store.getters.appSnackbar.color;
        }
        this.large = this.$store.getters.appSnackbar.large;
        this.show = this.$store.getters.appSnackbar.show;
        return this.$store.getters.appSnackbar.msg;
      } else {
        return "";
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/AppSnackbar.vue